module.exports = __webpack_public_path__ + "static/media/majors-student-law.a5b0e953.png";